module.exports = "pegasus/assets/theme2/medium/1.jpg";